module.exports = {"rAll":{"all":[8.4,254908],"kids":[8.8,1070],"youth":[8.7,121175],"middle":[8,54949],"old":[6.8,5983]},"rMale":{"all":[8.4,168228],"kids":[8.8,852],"youth":[8.7,103115],"middle":[8,47586],"old":[7,4904]},"rFemale":{"all":[8.3,27510],"kids":[8.8,215],"youth":[8.6,17297],"middle":[8,6793],"old":[6.2,980]},"rUS":[7.5,13265],"rNonUs":[8.3,107413],"title":"3 Idiots (2009)","rNum":{"1":7158,"2":1473,"3":1701,"4":2041,"5":3955,"6":7864,"7":20346,"8":43558,"9":66804,"10":100008},"totalVotes":254908,"rAvg":8.4,"id":"tt1187043","timeStamp":"Nov 26 2017, 23-03"}


//////////////////
// WEBPACK FOOTER
// ./src/data/3 Idiots (2009)Nov 26 2017, 23-03.json
// module id = 499
// module chunks = 0